import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { isEmpty, isNil } from 'lodash';

import { authActionStatusAtom, authErrorAtom } from 'Recoil/auth.atom';
import { authVerifyEmail } from 'Services/auth.services';

import VerifyEmailView from 'Components/auth/verify-email-view';

import './verify-email.scss';

interface Input {
  emailToken: string;
  passToken?: string;
  key: string;
}

const VerifyEmailPage = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [status, setStatus] = useRecoilState<any>(authActionStatusAtom);

  const handleVerifyEmail = async ({ emailToken, passToken, key }: Input) => {

    setStatus({ ...status, verifyEmail: 'loading' });
    const responseData = await authVerifyEmail({ verifyToken: emailToken, key });

    if (!isEmpty(responseData.error)) {
      setStatus({ ...status, verifyEmail: 'error' });
    }
    else {
      setStatus({ ...status, verifyEmail: 'success' });
      if (passToken) {
        history.push({ pathname: '/reset-password', search: `?passToken=${passToken}` });
      }
    }
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('pageTitle.verifyEmail')}</title>
        <meta name="robots" content="noindex"/>
      </Helmet>

      <div className="verify-email-page">
        <div className="verify-email-page--header">

        </div>

        <div className="verify-email-page--main">
          <div className="verify-email-page--container">
            <div className="verify-email-page--view">
              <div className="verify-email-page--view-title">
                <h3>{t('title.verifyEmail')}</h3>
              </div>

              <VerifyEmailView
                status={status.verifyEmail}
                onSetVerifyToken={handleVerifyEmail}
              />
            </div>
            <div className="verify-email-page--bot"></div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default VerifyEmailPage;
